module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALVJREFUWEft1TEOgkAQBdAPuAXHMjGhstZ4Oyip0ELiBai14whKR0fFmG3tZvjJxmT2APNf/mYyGRK/LHE+HOANeAPqBurucQoFXpdjNTJWWAVour6SVe4AphCKPQOhArTDUC6f+SYiBwBvBkIFiJWzEWoAG2ECMBFmAAuxCcBA/DeAsRHmBhjh8QtNAFa4CcAMVwPY4WpA8mMUxc21P+/y/Mm4hOoGGPf/d4ZpC5gQB3gD3sAXnm+sIUYIDjcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/a_right.png
// module id = bsMA
// module chunks = 0